var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMailSvgrepoCom = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Complete"
}, /*#__PURE__*/React.createElement("g", {
  id: "mail"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  points: "4 8.2 12 14.1 20 8.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  height: 14,
  rx: 2,
  ry: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  width: 18,
  x: 3,
  y: 6.5
}))))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMailSvgrepoCom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mail-svgrepo-com.40437383.svg";
export { ForwardRef as ReactComponent };